const shopCalendarWrapper = document.querySelector('.js-theshopcalendar-wrapper');
if(shopCalendarWrapper){
    // shopCalendarWrapper.addEventListener('DOMSubtreeModified',shopCalendarLoaded)
    const observer = new MutationObserver(mutationList =>
        mutationList.filter(m => m.type === 'childList').forEach(m => {
            m.addedNodes.forEach(shopCalendarLoaded);
        }));
    observer.observe(shopCalendarWrapper,{childList: true, subtree: false});
}
function shopCalendarLoaded(){
    if(shopCalendarWrapper.querySelectorAll('.tscCalendarContainer .tscListCard ')){
        let shopCalendarEvents =  shopCalendarWrapper.querySelectorAll('.tscCalendarContainer .tscListCard ');
        if(shopCalendarWrapper.querySelector('.tscCalendarContainer .tscListCard .tscListCardStartDate')){
            shopCalendarWrapper.removeEventListener('DOMSubtreeModified',shopCalendarLoaded);
        }
        fetch('https://www.theshopcalendar.com/9127e9bf-c25a-4209-937e-f784bd964fe4/events').then(function (response) {
            return response.json();
        }).then(function (responseJSON) {
            shopCalendarEvents.forEach(function (eventBlock){
                let blockTitle = eventBlock.querySelector('.tscListCardEventDetailsTitle').innerText.trim(),
                    dateWrapper = eventBlock.querySelector('.tscListCardDate'),
                    eventLink = eventBlock.querySelector('.tsc-event.tsc--eventModalLink'),
                    eventStartDate = document.createElement("div"),
                    eventEndDate = document.createElement("div");
                const shortTimeOptions = {
                    timezone: 'UTC',
                    hour: 'numeric',
                    minute: 'numeric'
                }
                const shortMonthOptions = {
                    month: 'short',
                    day: 'numeric',
                    timezone: 'UTC'
                }
                const dayOptions = {
                    day: 'numeric',
                    timezone: 'UTC'
                }
                if(eventLink){
                    eventLink.innerHTML = "DISCOVER NOW →"
                    eventLink.addEventListener('click', updateEventPopupDate)
                }
                if(blockTitle){
                    let currentEvent = responseJSON.find(event => event.title.toLowerCase() === blockTitle.toLowerCase());
                    if(dateWrapper && currentEvent){
                        let timeZone = new Date(currentEvent.start_date).getTimezoneOffset()*60000
                            currentEventStartDate =new Date(Date.parse(currentEvent.start_date) + timeZone),
                            currentEventEndDate =new Date(Date.parse(currentEvent.end_date) + timeZone);
                        eventStartDate.classList.add("tscListCardStartDate");
                        eventEndDate.classList.add("tscListCardEndDate");
                        if(currentEventStartDate.getMonth() < currentEventEndDate.getMonth()){
                            eventStartDate.innerHTML = `${currentEventStartDate.toLocaleString("en-US", shortMonthOptions)} - ${currentEventEndDate.toLocaleString("en-US", shortMonthOptions)}`;
                        }else if(currentEventStartDate.getMonth() == currentEventEndDate.getMonth() && currentEventStartDate.getDay() == currentEventEndDate.getDay()){
                            eventStartDate.innerHTML = `${currentEventEndDate.toLocaleString("en-US", shortMonthOptions)}`;
                        }else{
                            eventStartDate.innerHTML = `${currentEventStartDate.toLocaleString("en-US", shortMonthOptions)} - ${currentEventEndDate.toLocaleString("en-US", dayOptions)}`;
                        }
                        if(currentEventStartDate.getHours() > 12 && currentEventEndDate.getHours() > 12){
                            eventEndDate.innerHTML = `${currentEventStartDate.toLocaleString("en-US", shortTimeOptions).replace('PM', '')} - ${currentEventEndDate.toLocaleString("en-US", shortTimeOptions)}`;
                        }else if(currentEventStartDate.getHours() < 12 && currentEventEndDate.getHours() < 12){
                            eventEndDate.innerHTML = `${currentEventStartDate.toLocaleString("en-US", shortTimeOptions).replace('AM', '')} - ${currentEventEndDate.toLocaleString("en-US", shortTimeOptions)}`;
                        }else{
                            eventEndDate.innerHTML = `${currentEventStartDate.toLocaleString("en-US", shortTimeOptions)} - ${currentEventEndDate.toLocaleString("en-US", shortTimeOptions)}`;
                        }
                        // eventStartDate.innerHTML = `${currentEventStartDate.toLocaleString("en-US", longMonthOptions)}, ${currentEventStartDate.toLocaleString("en-US", shortTimeOptions)}`;
                        // eventEndDate.innerHTML = `${currentEventEndDate.toLocaleString("en-US", shortMonthOptions)}, ${currentEventEndDate.toLocaleString("en-US", shortTimeOptions)}`;
                        dateWrapper.innerHTML = "";
                        dateWrapper.appendChild(eventStartDate);
                        dateWrapper.appendChild(eventEndDate);
                        dateWrapper.classList.add("loaded");
                    }
                }
            })
        }).catch(function (err) {
            console.error('Something went wrong.', err);
        });
    }
}
function updateEventPopupDate(){
    let startDate = new Date(this.dataset.atcEventStart),
        endDate = new Date(this.dataset.atcEventEnd),
        eventStartDateText = '',
        eventEndDateText = '',
        eventPopup = document.querySelector('.tscModalCard');
    const shortTimeOptions = {
        timezone: 'UTC',
        hour: 'numeric',
        minute: 'numeric'
    }
    const shortMonthOptions = {
        month: 'short',
        day: 'numeric',
        timezone: 'UTC'
    }
    const dayOptions = {
        day: 'numeric',
        timezone: 'UTC'
    }
    const weekdayOptions = {
        weekday: "long",
        timezone: 'UTC'
    }
    if(startDate.getMonth() < endDate.getMonth()){
        eventStartDateText = `${startDate.toLocaleString("en-US", shortMonthOptions)}, ${startDate.toLocaleString("en-US", weekdayOptions)} - ${endDate.toLocaleString("en-US", shortMonthOptions)}, ${endDate.toLocaleString("en-US", weekdayOptions)}, `;
    }else if(startDate.getMonth() == endDate.getMonth() && startDate.getDay() == endDate.getDay()){
        eventStartDateText = `${startDate.toLocaleString("en-US", shortMonthOptions)}, ${startDate.toLocaleString("en-US", weekdayOptions)} `;
    }else{
        eventStartDateText = `${startDate.toLocaleString("en-US", shortMonthOptions)}, ${startDate.toLocaleString("en-US", weekdayOptions)} - ${endDate.toLocaleString("en-US", shortMonthOptions)}, ${endDate.toLocaleString("en-US", weekdayOptions)}, `;
    }

    if(startDate.getHours() > 12 && endDate.getHours() > 12){
        eventEndDateText = `${startDate.toLocaleString("en-US", shortTimeOptions).replace('PM', '')} - ${endDate.toLocaleString("en-US", shortTimeOptions)}`;
    }else if(startDate.getHours() < 12 && endDate.getHours() < 12){
        eventEndDateText = `${startDate.toLocaleString("en-US", shortTimeOptions).replace('AM', '')} - ${endDate.toLocaleString("en-US", shortTimeOptions)}`;
    }else{
        eventEndDateText = `${startDate.toLocaleString("en-US", shortTimeOptions)} - ${endDate.toLocaleString("en-US", shortTimeOptions)}`;
    }
    setTimeout(function (){
        if(eventPopup){
            let eventPopupStartDate = eventPopup.querySelector('.tscModalHeader .tscModalEventStart');
            let eventPopupEndDate = eventPopup.querySelector('.tscModalHeader .tscModalEventEnd');
            if(eventPopupStartDate){
                eventPopupStartDate.innerHTML = eventStartDateText;
            }
            if(eventPopupEndDate){
                eventPopupEndDate.innerHTML = eventEndDateText;
            }
            if(eventPopup.querySelector('.tscModalHeader > small')){
                eventPopup.querySelector('.tscModalHeader > small').innerHTML = ""
                eventPopup.querySelector('.tscModalHeader > small').appendChild(eventPopupStartDate);
                eventPopup.querySelector('.tscModalHeader > small').appendChild(eventPopupEndDate);
            }

        }
    }, 300)
}